import './labListComponent.scss'
import React, {useCallback, useState} from 'react';
import {ITableColumn} from "../../../shared/models/table.model";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import {CommonService} from "../../../shared/services";
import SwitchComponent from "../../../shared/components/core/switch/switchComponent";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {APIConfig, ImageConfig} from "../../../constants";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {ILab} from "../../../shared/models/lab.model";
import {Link} from "react-router-dom";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import commonService from "../../../shared/services/common.service";
import {ITimelineItem} from "../../../shared/models/timeline.model";


const MODULE_NAME = 'LabList';
const LAB_DETAILS = 'lab_details';
const LAB_ATTACHMENTS = 'lab_attachments';
const DIRECTOR_DETAILS = 'director_details';
const ADMIN_DETAILS = 'admin_details';
const TEST_AND_PANELS = 'test_and_panels';
const REPORT_SETUP = 'report_Setup';

const STEPS: ITimelineItem[] = [
    {
        id: LAB_DETAILS,
        title: "Lab Details",
    },
    {
        id: ADMIN_DETAILS,
        title: "Admin Details",
    },
    {
        id: DIRECTOR_DETAILS,
        title: "Director Details",
    },
    {
        id: TEST_AND_PANELS,
        title: "Test and Panels",
    },
    {
        id: LAB_ATTACHMENTS,
        title: "Attachments",
    },
    {
        id: REPORT_SETUP,
        title: "Report Setup",
    }
];

interface LabListComponentProps {
    filterData?: {};
}

const LabListComponent = (props: LabListComponentProps) => {

        const {filterData} = props;
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);

        const [columns] = useState<ITableColumn[]>([
            {
                id: 'name',
                label: 'Lab Name',
                isDefaultColumn: true,
                fixed: "left",
                width: "250",
                content: (item: ILab) => (
                    item.name ?
                        <>
                            {CommonService.capitalizeFirstLetterOfEachWord(item.name)}
                        </> : <>-</>
                )
            },
            {
                id: 'labType',
                label: 'Lab Type',
                isDefaultColumn: false,
                align: 'center',
                content: (item: ILab) => (
                    item.labType ?
                        <>
                            {CommonService.mapLabTypeToName(item.labType)}
                        </> : <>-</>
                )
            },
            {
                id: 'labRole',
                label: 'Lab Role',
                isDefaultColumn: true,
                align: 'center',
                width: "150",
                content: (item: ILab) => {
                    return (
                        CommonService.mapLabRoleToName(item.labRole) || 'N/A'
                    )
                }
            },
            {
                id: 'director',
                label: 'Director',
                isDefaultColumn: true,
                content: (item: ILab) => (
                    item.directorDetails ?
                        <>
                            {item.directorDetails ? (CommonService.capitalizeFirstLetterOfEachWord(item.directorDetails?.firstName + " " + (item.directorDetails?.middleName ? item.directorDetails?.middleName : "") + item.directorDetails?.lastName)) : "-"}
                        </> : <>-</>
                )
            },
            {
                id: 'mobileNumber',
                label: 'Mobile Number',
                align: 'center',
                isDefaultColumn: false,
                content: (item: ILab) => (
                    item.mobileNumber ?
                        <>
                            {CommonService.getMaskedMobileNumber(item.mobileNumber)}
                        </> : <>-</>
                )
            },
            {
                id: 'city',
                label: 'City',
                isDefaultColumn: false,
                align: 'center',
                width: "150",
                content: (item: ILab) => (
                    item.city ?
                        <>
                            {CommonService.capitalizeFirstLetter(item.city)}
                        </> : <>-</>
                )
            },
            {
                id: 'state',
                label: 'State',
                align: 'center',
                isDefaultColumn: false,
                width: "150",
                content: (item: ILab) => (
                    item.state ?
                        <>
                            {CommonService.capitalizeFirstLetter(item.state)}
                        </> : <>-</>
                )
            },

            {
                id: 'createdAt',
                label: 'Added Date & Time',
                align: 'center',
                isDefaultColumn: false,
                content: (item: ILab) => (
                    item.createdAt ?
                        <>
                            {commonService.formatDate(item?.createdAt)}
                            &nbsp;|&nbsp;
                            {commonService.formatTime(item?.createdAt)}
                        </> : <>-</>
                )
            },
            {
                id: 'addedBy', label: 'Added by', isDefaultColumn: false,
                align: 'center',
                content: (item: ILab) => (
                    <>
                        {item?.createdByDetails ? <>{CommonService.capitalizeFirstLetterOfEachWord(item?.createdByDetails?.firstName)} {CommonService.capitalizeFirstLetterOfEachWord(item?.createdByDetails?.lastName)}</> : '-'}
                    </>
                )
            },
            {
                id: 'status', label: 'Lab Status', isDefaultColumn: true, width: '150',
                align: 'center',
                content: (item: ILab) => (
                    item.status ?
                        <>
                            {item?.status ? <>
                                <ChipComponent className={`min-width-60 ${item?.status}`}
                                               label={CommonService.capitalizeFirstLetter(item?.status)}
                                               variant={"outlined"}/>
                            </> : <>-</>
                            }
                        </> : <>-</>

                )
            },
            {
                id: 'isActive',
                label: commonService.checkAccess('Lab', "labToggle", currentUser?.userAccessModules) ? 'Active/Inactive' : '',
                width: commonService.checkAccess('Lab', "labToggle", currentUser?.userAccessModules) ? "150" : "10",
                isDefaultColumn: true,
                align: 'center',
                content: (item: ILab, index: any) => (
                    <React.Fragment>
                        {
                            commonService.checkAccess('Lab', "labToggle", currentUser?.userAccessModules) ?
                                <SwitchComponent
                                    size={"small"}
                                    disabled={(item.status === 'draft')}
                                    checked={item.isActive}
                                    onUpdate={() => handleLabToggle(item)}/> :
                                <></>
                        }
                    </React.Fragment>
                )
            },
            {
                id: 'actions',
                label: '',
                isDefaultColumn: true,
                hideInColumnPreferences: true,
                width: '100',
                align: 'center',
                fixed: "right",
                content: (item: ILab, index: any) => (
                    <React.Fragment>
                        <div className="table-actions cursor-pointer">
                            {item?.status === "draft" ? <>
                                    <Link
                                        onClick={(e) => {
                                            if (!item.labRole) {
                                                e.preventDefault()
                                                CommonService._alert.showToast("Lab role is invalid", "warning");
                                                return;
                                            }
                                        }}
                                        to={CommonService._routeConfig.LabCreateRoute(item.labRole) + "?lastCompletedStep=" + (item?.lastCompletedStep ? item?.lastCompletedStep : 0) + `&labId=${item?.id}&step=${STEPS[item?.lastCompletedStep ? (item?.lastCompletedStep) : 1]?.id}`}>
                                        <div className="table-action">
                                            <ChevronRightIcon/>
                                        </div>
                                    </Link>
                                </> :
                                <Link
                                    onClick={(e) => {
                                        if (!item.labRole) {
                                            e.preventDefault()
                                            CommonService._alert.showToast("Lab role is invalid", "warning");
                                            return;
                                        }
                                    }}
                                    to={CommonService._routeConfig.LabDetailsRoute(item?.id, item.labRole)}>
                                    <div className="table-action">
                                        <ChevronRightIcon/>
                                    </div>
                                </Link>
                            }
                        </div>
                    </React.Fragment>
                )
            },
        ]);

        const onToggleLab = useCallback((item: any) => {
            CommonService._lab.toggleLabActiveStatus(item.id, {})
                .then((response: IAPIResponseType<any>) => {
                    CommonService._communications.TableWrapperRefreshSubject.next({
                        moduleName: MODULE_NAME
                    });
                    CommonService._alert.showToast(response?.message || `Lab has been  ${item?.isActive ? "deactivated" : "activated"}`, "success");
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.error || `Error while ${item?.isActive ? "deactivating" : "activating"} the Lab`, "error");
                });
        }, []);

        const handleLabToggle = useCallback((item: any) => {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Please confirm!',
                confirmationSubTitle: `Are you sure you want to ${item?.isActive ? "deactivate" : "activate"} this lab?`,
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.ConfirmationImage}`,
                direction: "up",
                yes: {
                    text: `${item?.isActive ? "Deactivate" : "Activate"}`,
                    color: "primary"
                },
                no: {
                    text: "Cancel",
                    color: "primary"
                }
            })
                .then(() => {
                    onToggleLab(item);
                })
                .catch(() => {
                })
        }, [onToggleLab]);

        return (
            <div className="table-list-container">
                <TableWrapperV2Component
                    isPaginated={true}
                    columns={columns}
                    url={APIConfig.LAB_LIST.URL}
                    method={APIConfig.LAB_LIST.METHOD}
                    extraPayload={filterData}
                    isColumnFilterVisible={true}
                    moduleName={MODULE_NAME}
                />
            </div>
        )

    }

;

export default LabListComponent;
